import {
  fetchInstrumentSetup,
  scanInstrumentSetup,
} from "../services/brokerIntegrationApi";
import type {
  InstrumentSetupResponse,
  InstrumentSetupSummary,
} from "../types/instrumentSetup";

/** Registry / sync says a full broker/source scan is required. */
export function instrumentSetupNeedsDeepScan(
  data: InstrumentSetupResponse | InstrumentSetupSummary | null | undefined
): boolean {
  const status = data?.scan_status?.trim().toLowerCase();
  return status === "needs_deep_scan" || status === "deferred" || status === "error";
}

/**
 * Open instrument-setup modal or settings page: always POST …/scan once.
 * Do not call this from Trade Review / sims — only when the user is in setup UI.
 */
export async function loadInstrumentSetupForDisplay(
  brokerAccountCode: string,
  _options?: { forceDeepScan?: boolean }
): Promise<InstrumentSetupResponse> {
  return scanInstrumentSetup(brokerAccountCode.trim());
}

/** After save/skip — GET only (batch save already gate-rescans changed symbols). */
export async function refreshInstrumentSetupAfterMutation(
  brokerAccountCode: string
): Promise<InstrumentSetupResponse> {
  return fetchInstrumentSetup(brokerAccountCode.trim());
}
